<div class="container flex column center">
  <h1 class="box" data-text="Grow">{{'WelcomePage.Title' | translate}}</h1>
  <span class="box details">{{'WelcomePage.Details' | translate}}</span>
  <span class="box details-sub">{{'WelcomePage.SubDetails' | translate}}</span>
</div>
